export default "__VITE_ASSET__8ce2c349__"